define(["./nlgAnalysisTreeModule", "../arrays/arrays"], function (module, arrays) {
    "use strict";
    return module.service("shadowTreeExpanderService", [function () {
        this.getExpanderByType = function (type) {
            switch (type) {
                case "ANALYSIS_TREE":
                    return analysisTreeExpander();
            }
        };

    }]);


    function analysisTreeExpander() {
        var expanderByType = {
            Trip: [],
            STOP: [],
            Order: [],
            Reorganized_Trips: []
        };


        return {
            addOrRemove: function (node) {
                var expanderIdentifiers = expanderByType[node.type.name];
                if (!expanderIdentifiers) {
                    return;
                }
                if (node.type.name === "Order") {
                    var orderIdentifier = getOrderIdentifier(expanderIdentifiers, node);
                    return manageTreeMemory({
                        id: node.id,
                        stopId: node.$parent.id
                    }, node, orderIdentifier, expanderIdentifiers);
                }
                var identifier = expanderIdentifiers.includes(node.id);
                manageTreeMemory(node.id, node, identifier, expanderIdentifiers);
            },
            addReorganizedTrip: function (node) {
                if (node.type.name === "Trip") {
                    expanderByType["Reorganized_Trips"].push(node.id);
                }
            },
            expand: function (node, expandOrCollapse) {
                node.children.forEach(function (tripNode) {
                        var reorganizedTrip = expanderByType["Reorganized_Trips"].includes(tripNode.id);
                        if (reorganizedTrip) {
                            return saveReorganizedTrips(expandOrCollapse, tripNode);
                        }
                        var trip = expanderByType[tripNode.type.name].includes(tripNode.id);
                        if (trip) {
                            expandOrCollapse(tripNode).then(function () {
                                tripNode.children.forEach(function (stopNode) {
                                    var stop = expanderByType[stopNode.type.name].includes(stopNode.id);
                                    if (stop) {
                                        stopNode.$opened = true;
                                        stopNode.children.forEach(function (orderNode) {
                                            if (getOrderIdentifier(expanderByType[orderNode.type.name], orderNode)) {
                                                orderNode.$opened = true;
                                            }
                                        });
                                    }
                                });
                            });
                        }
                    }
                );
            }
        };

        function manageTreeMemory(object, node, identifier, expanderIdentifiers) {
            if (node.$opened && !identifier) {
                expanderIdentifiers.push(object);
                return;
            }
            if (!node.$opened && identifier) {
                arrays.remove(expanderIdentifiers, object);
            }
        }

        function getOrderIdentifier(orders, node) {
            return orders.find(function (order) {
                return order.id === node.id && order.stopId === node.$parent.id;
            });
        }

        // Ao efetuar o encaixe, irá expandir a viagem e as paradas.
        function saveReorganizedTrips(expandOrCollapse, tripNode) {
            return expandOrCollapse(tripNode).then(function () {
                addIfNotExists(expanderByType["Trip"], tripNode.id);
                tripNode.children.forEach(function (stopNode) {
                    addIfNotExists(expanderByType["STOP"], stopNode.id);
                    stopNode.$opened = true;
                    expanderByType["Reorganized_Trips"] = [];
                });
            });
        }

        function addIfNotExists(array, object) {
            if (!array.includes(object)) {
                array.push(object);
            }
        }
    }
});